<section class="current-properties-section py-5">
  <div class="container mb-3">
    <app-section-title
      [inital]="title"
      [iscursive]="true"
      [title]="'Our Properties'"
      [subtitle]="'Explore Your Favourite Himalayan Getaways'"
    ></app-section-title>

    <app-tab
      [tabs]="isBrowser ? destinations : []"
      (tabSelected)="onTabChange($event)"
      [vScroll]="false"
      [hScroll]="true"
      class="w-100 d-flex justify-content-center"
      [selectedIndex]="selectedIndex"
    >
      <ng-template #tabLabel let-month>
        <div class="tab-label-container">
          <span class="dest-truncate" [title]="month.name">{{
            month.name
          }}</span>
        </div>
      </ng-template>
    </app-tab>
  </div>
  <app-property-card-carousel
    [properties]="hotels"
  ></app-property-card-carousel>
</section>
